import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const userDetailReducer = createReducer(initialState, {
  USER_DETAIL_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_PROFILE_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_PROFILE_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default userDetailReducer;
